<template>
  <div class="LoginBox">
  </div>
</template>

<script>
export default {
  name: 'LoginBox',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .LoginBox{
  width: 500px;
  height: 500px;
  position: absloute;
  background: pink;
} */
</style>



// WEBPACK FOOTER //
// src/components/LoginBox.vue